import React, { useEffect, useState } from "react";
import { Modal, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../utils/helper";

import { CircularProgress } from "../../components/UI/CircularProgress/CircularProgress";
import { getSession } from "../../reducers/selectors";
import { getAuthorizations } from "../../services/api/authorizations";
import { getLegalContracts, setLegalContract } from "../../services/api/person";
import { getMessages } from "../../services/api/internalMessages";
import {
  authorizationsSuccess,
  notificationsSuccess,
  setNotificationsLoading,
  textsSet,
  textsLoadingSet,
} from "../../actions/entities";
import { fetchTooltipsAndNotes } from "../../services/api/entities";

import style from "./LegalContracts.scss";
import { Container } from "../../components/UI/Container/Container";
import { Icons } from "../../components/UI/Icon/Icon";
import GenericButton from "../../components/UI/Button/Button";
import downloadIcon from "../../../public/svg/ButtonIcons/download.svg";

export const LegalContracts = () => {
  const session = useSelector(getSession);
  const [contract, setContract] = useState(null);
  const [contractLoading, setContractLoading] = useState(false);
  const [contractLoaded, setContractLoaded] = useState(false);
  const [updateContractLoading, setUpdateContractLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!contractLoading && session && !contract && !contractLoaded) {
      updateLegalContract();
    }
  }, [session]);

  const updateLegalContract = () => {
    setContractLoading(() => true);
    getLegalContracts()
      .then(({ response }) => {
        if (response.result.Code !== 200) {
          showToast("Error obteniendo nuevos contratos del servidor", true);
        } else {
          if (response.LegalContractSDT.LegalContractAttachmentName) {
            setContract({
              ...response.LegalContractSDT,
              LegalContractAttachmentBlob: response.blobfile,
            });
          }
          setContractLoaded(() => true);
        }
      })
      .catch((err) => {
        console.error(err);
        showToast("Error obteniendo nuevos contratos del servidor", true);
      })
      .finally(() => {
        setContractLoading(() => false);
      });
  };

  const getFile = () => {
    var a = document.createElement("A");
    a.href = `data:application/octet-stream;base64,${contract.LegalContractAttachmentBlob}`;
    a.download = `${contract.LegalContractAttachmentName}.${contract.LegalContractAttachmentExtension}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleAuthorizeContract = (payload) => {
    if (!updateContractLoading) {
      setContractLoading(() => true);
      setUpdateContractLoading(() => true);
      setLoading(() => true);
      setLegalContract({ LegalContractId: contract.LegalContractId })
        .then(({ response }) => {
          if (response.result.Code === 200) {
            showToast("Contrato confirmado correctamente");
          }
        })
        .catch((err) => {
          showToast("Error confirmando el contrato", true);
          console.error(err);
        })
        .finally(() => {
          setContractLoading(() => false);
          setUpdateContractLoading(() => false);
          setTimeout(() => {
            window.location.href = "/";
          }, 3000);
        });
    }
  };

  const [checked, setChecked] = useState(false);

  const handleChangeCheckbox = () => {
    setChecked((prevState) => !prevState);
  };
  return (
    <Modal isOpen={contract} className={style.modalWrapper}>
      <Container className={style.contractContainer}>
        <span className={style.contractTitle}>Aceptá el Contrato legal</span>
        <div className={style.text}>Revisá el siguiente documento:</div>
        <div className={style.contractFileCard}>
          <div className={style.boxContract}>
            <Icons.FileIcon size="md" />
            <div>
              <p className={style.contractPdf}>
                {contract && contract.LegalContractAttachmentName
                  ? `${contract.LegalContractAttachmentName}.${contract.LegalContractAttachmentExtension}`
                  : "No hay contratos disponibles."}
              </p>
            </div>
          </div>
          <div className={style.pdfButtons}>
            <div className={style.downloadPdf}>
              <GenericButton
                handleClick={getFile}
                right
                rounded
                width={"200px"}
                marginLeft={"0px"}
                label={"Descargar PDF"}
                padding={"10px 22px"}
                iconSvg={[{ width: "24px", item: downloadIcon }]}
              ></GenericButton>
            </div>
          </div>
        </div>
        <div className={style.chekboxContract}>
          <span onClick={handleChangeCheckbox}>
            {checked ? (
              <Icons.CheckboxCheckedIcon className={style.icon} />
            ) : (
              <Icons.CheckboxUncheckedIcon className={style.icon} />
            )}
          </span>
          <p className={style.textAcceptContract} onClick={handleChangeCheckbox}>
            He leído, comprendido y acepto los términos y condiciones del documento que acabo de leer
          </p>
        </div>

        {loading ? (
          <CircularProgress />
        ) : (
          <Button
            className={style.buttonConfirmContract}
            onClick={handleAuthorizeContract}
            disabled={loading || !checked}
          >
            Confirmar
          </Button>
        )}
      </Container>
    </Modal>
  );
};
